import * as moment from "moment";
import { LinkObject } from "@teamprevent/common/model";

import { SraCustomerState } from "../sraCustomer";

import { Location } from "redux-little-router";

export interface SraCustomerUserListModel {
    readonly id: string;
    readonly sraCustomerId?: string;
    readonly firstName?: string;
    readonly lastName?: string;
    readonly emailAddress?: string;
    readonly listUpdated?: moment.Moment;
}

export interface SraCustomerUserDetailModel {
    readonly id: string;
    readonly sraCustomerId?: string;
    readonly firstName?: string;
    readonly lastName?: string;
    readonly department?: LinkObject;
    readonly emailAddress?: string;
    readonly roles?: string[];
    readonly detailUpdated?: moment.Moment;
}

export type SraCustomerUser = SraCustomerUserListModel & SraCustomerUserDetailModel;

export interface SraCustomerUserCreateModel {
    id: string;
    firstName: string;
    lastName: string;
    departmentId: string;
    emailAddress: string;
    roles: string[];
}

export interface SraCustomerUserEditModel {
    id: string;
    firstName: string;
    lastName: string;
    departmentId: string;
    emailAddress: string;
    roles: string[];
}

export interface SraCustomerUserState {
    readonly sraCustomerUsers: SraCustomerUser[];
    readonly sraCustomerUser?: SraCustomerUser;
}

export const SRA_CUSTOMER_USER_ROLES = {
    SUPER_USER: { displayName: "Super User", name: "SuperUser" },
    MANAGER: { displayName: "Manager", name: "Manager" }
};

export class SraCustomerUserBuilder {
    private id: string;
    private firstName: string;
    private lastName: string;
    private departmentId: string;
    private emailAddress: string;
    private roles: string[];

    constructor() {
        this.firstName = "Test 1";
        this.lastName = "Test 1";
        this.departmentId = "Test 1";
        this.emailAddress = "Test 1";
        this.roles = [];
    }

    public withId(id: string): SraCustomerUserBuilder {
        this.id = id;
        return this;
    }

    public withfirstName(firstName: string): SraCustomerUserBuilder {
        this.firstName = firstName;
        return this;
    }

    public withlastName(lastName: string): SraCustomerUserBuilder {
        this.lastName = lastName;
        return this;
    }

    public withdepartmentId(departmentId: string): SraCustomerUserBuilder {
        this.departmentId = departmentId;
        return this;
    }

    public withemailAddress(emailAddress: string): SraCustomerUserBuilder {
        this.emailAddress = emailAddress;
        return this;
    }

    public withroles(roles: string[]): SraCustomerUserBuilder {
        this.roles = roles;
        return this;
    }

    public build(): SraCustomerUserEditModel {
        return {
            id: this.id,
            firstName: this.firstName,
            lastName: this.lastName,
            departmentId: this.departmentId,
            emailAddress: this.emailAddress,
            roles: this.roles,
        };
    }

}

export type AppState = SraCustomerUserState & { router: Location } & SraCustomerState;
